// extracted by mini-css-extract-plugin
module.exports = {"sticky":"StickyWrapper_sticky__2K1-C","bottom":"StickyWrapper_bottom__38Jh9","top":"StickyWrapper_top__KO2Bt","stickyFallback":"StickyWrapper_stickyFallback__2TT-x"};